var map = {
	"./common/card.jpg": 3420,
	"./common/code.jpg": 9279,
	"./common/global.svg": 1218,
	"./common/loading.svg": 9802,
	"./common/logo_large.png": 3003,
	"./common/logo_origion.png": 7089,
	"./common/logo_small.png": 8661,
	"./common/menu-fold.svg": 9665,
	"./common/menu-unfold.svg": 7494,
	"./en/Anti_Counterfeiting.jpg": 9961,
	"./en/logo.png": 3041,
	"./zh-CN/Anti_Counterfeiting.jpg": 6181,
	"./zh-CN/logo.png": 9629,
	"./zh-TW/logo.png": 6924,
	"images/common/card.jpg": 3420,
	"images/common/code.jpg": 9279,
	"images/common/global.svg": 1218,
	"images/common/loading.svg": 9802,
	"images/common/logo_large.png": 3003,
	"images/common/logo_origion.png": 7089,
	"images/common/logo_small.png": 8661,
	"images/common/menu-fold.svg": 9665,
	"images/common/menu-unfold.svg": 7494,
	"images/en/Anti_Counterfeiting.jpg": 9961,
	"images/en/logo.png": 3041,
	"images/zh-CN/Anti_Counterfeiting.jpg": 6181,
	"images/zh-CN/logo.png": 9629,
	"images/zh-TW/logo.png": 6924
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5608;